define('common/markdown',['showdown', 'showdownTable'], function (Showdown) {

    var converter = new Showdown.converter({ extensions: ['table'] });

    var MarkdownViewModel = function () {
        this.convert = function(markdownString) {
            return converter.makeHtml(markdownString);
        };
    };

    return new MarkdownViewModel();
});
